import loadable from '@loadable/component';

export const MfaPageLoadable = loadable(() => import('./MfaPage'), {
  resolveComponent: (module) => module.MfaPage,
});
